var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-row-header bg-white sticky-top p-2 js-file-row-header",attrs:{"title":_vm.path}},[_c('gl-truncate',{staticClass:"bold",attrs:{"text":_vm.path,"position":"middle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }